import { venuePages, venueTabs } from '../content.js'
import Slideshow from '../components/Slideshow.jsx'

// The tab bar in each venue page screenshot works like the real page: a tab opens its slide.
const tabSpots = (slide) => (venueTabs.layout[slide.shot] || []).map(([label, left, width]) => (
  { label, left, width, top: venueTabs.top, height: venueTabs.height, target: venueTabs.target[label] }
))

export default function VenuePages() {
  return (
    <section className="section alt" id="venue-pages">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow">{venuePages.eyebrow}</span>
          <h2>{venuePages.title}</h2>
          <p>{venuePages.text}</p>
        </div>
        <Slideshow slides={venuePages.pages} wide noun="page" labelPrefix="VenueLista venue page: " hotspots={tabSpots} />
      </div>
    </section>
  )
}
